/* global ol */

/**
 * Sets the default style for all select interactions to the selected feature's layer style.
 * (By default the feature's icon will be replaced with a blue dot on select.)
 */

function SelectInteractionStyle(map) {
  this.map = map;

  this.interaction = new ol.interaction.Select({
    condition: ol.events.condition.pointerMove,
    toggleCondition: ol.events.condition.never,
    style: this.style
  });
}

SelectInteractionStyle.prototype.style = function(feature, resolution) {
  var features = feature.get('features');
  var layer = (features ? features[0] : feature).get('layer');

  return layer.layer.getStyle()(feature, resolution);
};

// Force the selected feature to redraw in case it's style is updated while hovering
SelectInteractionStyle.prototype.redrawStyle = function() {
  if (this.interaction.getFeatures().getLength()) {
    this.interaction.setMap(null);
    this.interaction.setMap(this.map);
  }
};

module.exports = SelectInteractionStyle;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/selectInteractionStyle.js
 ** module id = 190
 ** module chunks = 1
 **/